import { Box, Typography } from '@mui/material'

export const GddChartTooltip = ({ active, payload, theme }) => {
  if (!active || !payload?.length) return null

  const avg = payload.find(p => p.dataKey === 'avg')
  const std = payload[0]?.payload?.std

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        px: 1,
        py: 0.5,
        boxShadow: theme.shadows[2],
      }}
    >
      {avg && (
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.primary', display: 'block' }}>
          Avg: {avg.value} GDD
        </Typography>
      )}
      {std != null && (
        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
          ±{std} GDD
        </Typography>
      )}
      {/* TODO current value in success.main */}
    </Box>
  )
}
